<template>
  <div>
    <div class="ui-tabs">
      <ul class="ui-tabs__ul">
        <li v-for="tab in tabs" :key="tab.id" class="ui-tabs__tab"
          :class="[activeTab === tab.id ? 'ui-tabs__tab--active' : 'ui-tabs__tab']" @click="onChangeTab(tab.id)">
          {{ tab.label }}
        </li>
      </ul>
      <div class="ui-tabs__content" v-if="!isLoading">
        <Intro @categoryUpdated="onCategoryUpdated" v-if="activeTab === compliceKey.intro" />
        <FileUploader :key="activeTabKey" :category="integrityComplianceKey.compliance" :subcategory="activeTab"
          :files="categoryFiles" :title="getActiveTab.label" @createdFile="onCreatedFile"
          v-if="activeTab === compliceKey.code_of_conduct || activeTab === compliceKey.anticorruption || activeTab === compliceKey.prevention_of_money_laundering || activeTab === compliceKey.human_rights || activeTab === compliceKey.BPDD" />
      </div>
    </div>
  </div>
</template>


<script>
const Intro = () => import("@/components/IntegrityCompliance/Compliance/Intro");
const FileUploader = () => import("@/components/IntegrityCompliance/FileUploader");
import API_SERVICE from "@/lib/api/IntegrityCompliance.js";
const api = new API_SERVICE();

import { compliceKey, integrityComplianceKey } from "@/lib/constants.js";
export default {
  inject: ['IC_getMainCategory'],
  components: {
    Intro,
    FileUploader
  },
  async mounted () {
    this.category = this.IC_getMainCategory();
    await this.getCategoryDetail();
  },
  computed: {
    tabs() {
      return [
        {
          id: compliceKey.intro,
          label: this.$t("integrityCompliance.complice.intro")
        },
        {
          id: compliceKey.code_of_conduct,
          label: this.$t("integrityCompliance.complice.code_of_conduct")
        },
        {
          id: compliceKey.anticorruption,
          label: this.$t("integrityCompliance.complice.anticorruption")
        },
        {
          id: compliceKey.prevention_of_money_laundering,
          label: this.$t("integrityCompliance.complice.prevention_of_money_laundering")
        },
        {
          id: compliceKey.human_rights,
          label: this.$t("integrityCompliance.complice.human_rights")
        },
        {
          id: compliceKey.BPDD,
          label: this.$t("integrityCompliance.complice.BPDD")
        },
      ]
    },
    categoryFiles() {
      return this.category.files
    },
    getActiveTab() {
      return this.tabs.find(({ id }) => id === this.activeTab)
    }
  },
  data() {
    return {
      isLoading: false,
      activeTab: compliceKey.intro,
      compliceKey,
      integrityComplianceKey,
      category: {}
    }
  },
  methods: {
    onChangeTab(tabId) {
      this.activeTab = tabId;
      this.activeTabKey = `${this.activeTab}_${new Date().getTime()}`;
    },
    async getCategoryDetail() {
      try {
        this.isLoading = true;
        this.category = await api.getCategory(this.category.id);
      } catch (error) {
        console.error(error);
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('integrityCompliance.complice.getError'),
          show: true,
          type: "error"
        });
      } finally {
        this.isLoading = false;
      }
    },
    onCreatedFile(fileData) {
      this.category.files.push(fileData);
    },
    onCategoryUpdated(categoryData) {
      this.$emit('categoryUpdated', categoryData)
    }
  }
}
</script>